import DrinksMenuRow from "./DrinksMenuRow";
import DrinksMenuSketch from "./DrinksMenuSketch";
import { splitColumns } from "../../../data/drinksMenuLayout";

function DrinksMenuPanel({ panel, lang, onOpen }) {
  if (!panel) return null;

  const columns = splitColumns(
    panel.items,
    panel.columns,
    panel.leftCount
  );

  return (
    <article
      className={`drinks-menu-panel drinks-menu-panel--${panel.area}`}
      style={{ gridArea: panel.area }}
    >
      <span className="drinks-menu-corner drinks-menu-corner--tl" aria-hidden="true" />
      <span className="drinks-menu-corner drinks-menu-corner--tr" aria-hidden="true" />
      <span className="drinks-menu-corner drinks-menu-corner--bl" aria-hidden="true" />
      <span className="drinks-menu-corner drinks-menu-corner--br" aria-hidden="true" />

      <header className="drinks-menu-panel-header">
        <span className="drinks-menu-panel-bean" aria-hidden="true" />
        <h3 className="drinks-menu-panel-title">{panel.title}</h3>
      </header>
      <div className="drinks-menu-panel-rule" aria-hidden="true" />

      <div
        className={
          columns.length > 1
            ? "drinks-menu-panel-cols"
            : "drinks-menu-panel-list-wrap"
        }
      >
        {columns.map((colItems, colIndex) => (
          <ul key={colIndex} className="drinks-menu-list">
            {colItems.map((item) => (
              <DrinksMenuRow
                key={item.id}
                item={item}
                lang={lang}
                onOpen={onOpen}
                showDescription={Boolean(panel.showDescriptions)}
              />
            ))}
          </ul>
        ))}
      </div>

      {panel.note ? (
        <p className="drinks-menu-panel-note">{panel.note}</p>
      ) : null}

      <DrinksMenuSketch type={panel.sketch} />
    </article>
  );
}

export default DrinksMenuPanel;
